import { EMPTY_ARRAY } from 'commons-ui';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES } from 'constant';
import usePermission from 'commons-ui/src/permission/usePermission';
import { AthenaCrudRequestRecord } from '../types';
import { AthenaCrudAction, AthenaCrudActionLabel, AthenaCrudRequestStatus } from '../models';
import { EAthenaDashboardResources } from '../../helper';

export const makeActionList = () => {
	const { hasPermission } = usePermission();
	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: AthenaCrudActionLabel[AthenaCrudAction.VIEW],
				id: AthenaCrudAction.VIEW,
				isEnabled: () => {
					return hasPermission({
						configPageName: DASHBOARD_RESOURCES.athenaDashboard,
						configResourceName: EAthenaDashboardResources.REQUEST_LIST
					});
				}
			},
			{
				name: AthenaCrudActionLabel[AthenaCrudAction.APPROVE],
				id: AthenaCrudAction.APPROVE,
				isEnabled: (rowData: AthenaCrudRequestRecord) => {
					const { status } = rowData;
					if (status !== AthenaCrudRequestStatus.WAITING_FOR_APPROVAL) {
						return false;
					}
					return hasPermission({
						configPageName: DASHBOARD_RESOURCES.athenaDashboard,
						configResourceName: EAthenaDashboardResources.REQUEST_LIST,
						configActionName: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].approveAthenaCrudRequest
					});
				}
			},
			{
				name: AthenaCrudActionLabel[AthenaCrudAction.REJECT],
				id: AthenaCrudAction.REJECT,
				isEnabled: (rowData: AthenaCrudRequestRecord) => {
					const { status } = rowData;
					if (status !== AthenaCrudRequestStatus.WAITING_FOR_APPROVAL) {
						return false;
					}
					return hasPermission({
						configPageName: DASHBOARD_RESOURCES.athenaDashboard,
						configResourceName: EAthenaDashboardResources.REQUEST_LIST,
						configActionName: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].rejectAthenaCrudRequest
					});
				}
			},
			{
				name: AthenaCrudActionLabel[AthenaCrudAction.EDIT],
				id: AthenaCrudAction.EDIT,
				isEnabled: () => {
					return hasPermission({
						configPageName: DASHBOARD_RESOURCES.athenaDashboard,
						configResourceName: EAthenaDashboardResources.REQUEST_LIST,
						configActionName: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].updateAthenaCrudRequest
					});
				}
			},
			{
				name: AthenaCrudActionLabel[AthenaCrudAction.VERSION_HISTORY],
				id: AthenaCrudAction.VERSION_HISTORY,
				isEnabled: () => {
					return hasPermission({
						configPageName: DASHBOARD_RESOURCES.athenaDashboard,
						configResourceName: EAthenaDashboardResources.REQUEST_LIST,
						configActionName: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].getAthenaCrudRequestVersionHistory
					});
				}
			}
		],
		addAction: {
			name: AthenaCrudActionLabel[AthenaCrudAction.ADD],
			id: AthenaCrudAction.ADD,
			isEnabled: () => {
				return hasPermission({
					configPageName: DASHBOARD_RESOURCES.athenaDashboard,
					configResourceName: EAthenaDashboardResources.REQUEST_LIST,
					configActionName: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].createAthenaCrudRequest
				});
			}
		}
	};
};

export default {
	makeActionList
};
